export const UserGroupMutations = {
  setUserGroups (state, groups) { state.groups = groups || [] },
}
